var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceMissingMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 53,
    viewBox: "0 0 189 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3448 274.666C94.9522 275.286 94.0478 275.286 93.6552 274.666L46.5419 200.285C46.1202 199.619 46.5985 198.75 47.3867 198.75H141.613C142.401 198.75 142.88 199.619 142.458 200.285L95.3448 274.666Z",
    fill: "#46526C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    fill: "#46526C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3698 45H36V68.0438H42.3698V45Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0437 45H36V51.3698H59.0437V45Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 45H145.414V68.0438H151.784V45Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.755 45H128.711V51.3698H151.755V45Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3698 119.699H36V142.743H42.3698V119.699Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0437 136.348H36V142.717H59.0437V136.348Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 119.699H145.414V142.743H151.784V119.699Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.755 136.348H128.711V142.717H151.755V136.348Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2945 103.531C91.3212 100.801 91.5621 98.9272 91.9904 97.8567C92.4186 96.7861 93.623 95.4212 95.55 93.6815C97.3967 91.4601 98.7348 89.8008 99.5378 88.5964C100.341 87.392 100.742 85.9735 100.742 84.3142C100.742 82.3069 100.207 80.7813 99.1363 79.7108C98.0658 78.6402 96.567 78.1049 94.5597 78.1049C92.8468 78.1049 91.4015 78.5867 90.1704 79.5235C88.9393 80.4602 88.3505 81.8252 88.3505 83.6184H83.0512L82.9709 83.431C82.8906 80.3799 83.9879 77.9711 86.1558 76.1244C88.3237 74.3045 91.1339 73.3945 94.5597 73.3945C98.2531 73.3945 101.17 74.3313 103.204 76.2315C105.265 78.1317 106.282 80.7813 106.282 84.1536C106.282 86.5891 105.64 88.8105 104.275 90.8446C102.91 92.8786 101.197 94.9127 99.0025 97.027C97.9855 98.044 97.3699 98.9541 97.1558 99.757C96.9417 100.56 96.8346 101.818 96.8346 103.531H91.2677H91.2945ZM97.0755 115.119H91.2677V109.231H97.0755V115.119Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceMissingMarker);
export default __webpack_public_path__ + "static/media/face-missing_marker.9773042c9473a38689960a71e984f798.svg";
export { ForwardRef as ReactComponent };